function CloseIcon({ size = '22', style = {}, color = '#959FAF' }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.53033 0.46967C1.23744 0.176777 0.762563 0.176777 0.46967 0.46967C0.176777 0.762563 0.176777 1.23744 0.46967 1.53033L9.93934 11L0.46967 20.4697C0.176777 20.7626 0.176777 21.2374 0.46967 21.5303C0.762563 21.8232 1.23744 21.8232 1.53033 21.5303L11 12.0607L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L12.0607 11L21.5303 1.53033C21.8232 1.23744 21.8232 0.762565 21.5303 0.469672C21.2374 0.176778 20.7626 0.176779 20.4697 0.469672L11 9.93934L1.53033 0.46967Z"
        fill={color}
      />
    </svg>
  );
}

export default CloseIcon;
